export const PAIS = 'P';
export const REGION = 'R';
export const CLUBES = 'C';
export const SELECCIONES = 'S';
export const MIXTOS = 'M';
